module.exports = __webpack_public_path__ + "img/opengraph.7ed785f3.jpg";